export function printArticle() {
	if ($(".article").length) {
		$("body").addClass('print-page');
	}

	$('.print-ico a').on('click', function (e) {
		window.print();
		e.preventDefault();
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/printArticle.js